import {
    ChangeDetectorRef,
    Component,
    forwardRef,
    HostBinding,
    Input,
    ViewChild,
    ViewEncapsulation,
} from "@angular/core";
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from "@angular/forms";
import { MatDialog } from "@angular/material/dialog";
import { ImageEditorDialogComponent } from "./image-editor-dialog.component";
import { DomSanitizer, SafeUrl } from "@angular/platform-browser";
import { Injector } from "@angular/core";
import { NgxFileDropComponent, NgxFileDropEntry, NgxFileDropModule } from "ngx-file-drop";
import { CommonModule } from "@angular/common";
import {TranslocoDirective} from "@jsverse/transloco";

@Component({
    selector: "image-editor-widget",
    templateUrl: "image-editor-widget.component.html",
    styleUrls: ["image-editor-widget.component.scss"],
    encapsulation: ViewEncapsulation.None,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => ImageEditorWidgetComponent),
            multi: true,
        },
    ],
    imports: [CommonModule, NgxFileDropModule, TranslocoDirective],
    standalone: true,
})
export class ImageEditorWidgetComponent implements ControlValueAccessor {
    @ViewChild("fileDrop") fileDrop: NgxFileDropComponent;

    @Input()
    placeholder: string;

    @HostBinding("style.width")
    @Input()
    with: string;

    @HostBinding("style.height")
    @Input()
    height: string;

    @Input()
    accept: string = "image/png";

    @HostBinding("crop.width")
    @Input()
    cropWidth: number;

    @HostBinding("crop.height")
    @Input()
    cropHeight: number;

    @HostBinding("crop.title")
    @Input()
    cropTitle: string;

    @HostBinding("crop.subtitle")
    @Input()
    cropSubTitle: string;

    @Input()
    showPickOption: boolean = true;

    imageValue: string;
    propagateChange = (_: any) => {};

    imageUrl: SafeUrl;

    hasImage: boolean = false;

    dialogRef: any;

    @Input()
    title: string;

    disabled: boolean;

    constructor(
        injector: Injector,
        public _matDialog: MatDialog,
        private _sanitizer: DomSanitizer,
        private _cdr: ChangeDetectorRef
    ) {}

    writeValue(obj: any): void {
        this.imageValue = obj;
        if (obj) {
            this.imageUrl = this._sanitizer.bypassSecurityTrustUrl(obj);
        } else {
            this.imageUrl = null;
        }

        this.hasImage = !!obj;

        this._cdr.detectChanges();
    }

    registerOnChange(fn: any): void {
        this.propagateChange = fn;
    }

    registerOnTouched(fn: any): void {
        // throw new Error('Method not implemented.');
    }

    setDisabledState?(isDisabled: boolean): void {
        this.disabled = isDisabled;

        if (isDisabled) {
            this.imageUrl = null;
        }
    }

    onOpenFileExplorer() {
        this.openEditor(null, true);
    }

    public dropped(files: NgxFileDropEntry[]) {
        if (files && files.length > 0) {
            let droppedFile = files[0];
            // Is it a file?
            if (
                droppedFile.fileEntry.isFile &&
                this.accept.split(",").findIndex((i) => droppedFile.fileEntry.name.toLowerCase().endsWith(i)) >= 0
            ) {
                this.openEditor(droppedFile, null);
            } else {
                // It was a directory (empty directories are added, otherwise only files)
                // const fileEntry = droppedFile.fileEntry as FileSystemDirectoryEntry;
                // console.log(droppedFile.relativePath, fileEntry);
                //this.notify.info("Arquivo inválido. Somente imagens (.jpg, .png) são permitidas.");
            }
        }
    }

    openEditor(droppedFile?: NgxFileDropEntry, openExplorerOnStartup?: boolean) {
        let settings = {};
        if (this.cropWidth) {
            settings["width"] = this.cropWidth;
        }
        if (this.cropHeight) {
            settings["height"] = this.cropHeight;
        }
        let dialogRef = this._matDialog.open(ImageEditorDialogComponent, {
            panelClass: "image-editor-dialog",
            data: {
                accept: this.accept,
                droppedFile: droppedFile ? droppedFile : null,
                openExplorerOnStartup: openExplorerOnStartup,
                settings: settings,
            },
        });
        dialogRef.afterClosed().subscribe((response: any) => {
            if (response && response.url) {
                this.writeValue(response.url);
                this.propagateChange(this.imageValue);
            }
        });
    }
}
